(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      /* ✅ 首页覆盖模式：不允许下滑时隐藏 header（一直粘在顶部） */
      if (this.classList.contains('header-wrapper--home-overlay')) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
        return;
      }

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ✅ 首页：滚动、hover、focus、菜单打开 时切换状态
     - is-scrolled：滚动后（恢复正常）
     - is-hovered：hover/focus/menu-open（恢复正常）=> 这就是你要的 “hover = 下滑后的样式”
  */
  (() => {
    const wrapper = document.querySelector('.header-wrapper--home-overlay');
    if (!wrapper) return;

    const detailsEls = wrapper.querySelectorAll('details');

    let hovering = false;
    let focusing = false;
    let anyOpen = false;

    const refreshAnyOpen = () => {
      anyOpen = Array.from(detailsEls).some((d) => d.open);
    };

    const applyStates = () => {
      // 滚动：恢复正常样式
      wrapper.classList.toggle('is-scrolled', window.scrollY > 10);

      // hover/focus/open：恢复正常样式（和 is-scrolled 一样）
      const shouldNormal = hovering || focusing || anyOpen;
      wrapper.classList.toggle('is-hovered', shouldNormal);
    };

    // scroll
    applyStates();
    window.addEventListener('scroll', applyStates, { passive: true });

    // hover (desktop)
    wrapper.addEventListener('mouseenter', () => {
      hovering = true;
      applyStates();
    });
    wrapper.addEventListener('mouseleave', () => {
      hovering = false;
      applyStates();
    });

    // focus (keyboard / clicking icons)
    wrapper.addEventListener('focusin', () => {
      focusing = true;
      applyStates();
    });
    wrapper.addEventListener('focusout', () => {
      // 等浏览器把 focus 真正移走后再判断
      setTimeout(() => {
        focusing = wrapper.matches(':focus-within');
        applyStates();
      }, 0);
    });

    // details open (dropdown/mega/search)
    detailsEls.forEach((d) =>
      d.addEventListener('toggle', () => {
        refreshAnyOpen();
        applyStates();
      })
    );

    // init open state
    refreshAnyOpen();
    applyStates();
  })();

  } catch(e) { console.error(e); }
})();
})();
